// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"App_mainHeader__3L_RI","hero":"App_hero__NQGkv","text":"App_text__PPQbm","flourish":"App_flourish__2OQ4v"};